import React from "react";
import { SvgIcon } from "../../components/SvgComponents";
import { interpolate, spring, useVideoConfig } from "remotion";
import { BulletItem } from "../../types";
import { CompanyBadge } from "../../components/CompanyBadge";
import { detectBrandInText } from "../../components/companyDetector";


interface VelocityTechInsightsProps {
  bullets: BulletItem[];
  globalFrame: number;
}

export const VelocityTechInsights: React.FC<VelocityTechInsightsProps> = ({
  bullets,
  globalFrame,
}) => {
  const { fps } = useVideoConfig();
  const currentMs = (globalFrame / fps) * 1000;

  // Identify active bullet
  let activeIndex = bullets.findIndex(
    (b) => currentMs >= b.startMs && currentMs <= b.endMs
  );

  if (activeIndex === -1) {
    const pastBullets = bullets.filter((b) => b.endMs <= currentMs);
    activeIndex = pastBullets.length > 0 ? pastBullets.length - 1 : 0;
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        padding: "20px 40px",
        gap: "20px",
        zIndex: 20,
      }}
    >
      {bullets.map((bullet, i) => {
        const bulletStartFrame = (bullet.startMs / 1000) * fps;
        const elapsed = Math.max(0, globalFrame - bulletStartFrame);
        const isActive = i === activeIndex;

        const entrance = spring({
          frame: elapsed,
          fps,
          config: { stiffness: 120, damping: 14 },
        });

        const slideX = interpolate(entrance, [0, 1], [-30, 0]);
        const opacity = interpolate(entrance, [0, 1], [0, 1]);

        return (
          <div
            key={i}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "24px",
              padding: "24px",
              background: isActive
                ? "rgba(0, 212, 255, 0.08)"
                : "rgba(255, 255, 255, 0.03)",
              borderLeft: `4px solid ${isActive ? "#ccff00" : "rgba(255,255,255,0.1)"}`,
              borderRadius: "0 8px 8px 0",
              opacity,
              transform: `translateX(${slideX}px)`,
            }}
          >
            <div
              style={{
                width: "60px",
                height: "60px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: isActive ? "rgba(204, 255, 0, 0.1)" : "transparent",
                borderRadius: "50%",
                flexShrink: 0,
              }}
            >
              {(() => {
                const brand = detectBrandInText(bullet.text);
                return brand ? (
                  <CompanyBadge
                    name={brand}
                    color={isActive ? "#ccff00" : "#94a3b8"}
                    accentColor={isActive ? "#ccff00" : "#94a3b8"}
                    size={36}
                    style="minimal"
                  />
                ) : (
                  <SvgIcon
                    name={bullet.icon || "zap"}
                    width={36}
                    height={36}
                    primaryColor={isActive ? "#ccff00" : "#94a3b8"}
                  />
                );
              })()}
            </div>
            <p
              style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: "28px",
                fontWeight: isActive ? 700 : 500,
                color: isActive ? "white" : "#94a3b8",
                margin: 0,
                lineHeight: 1.3,
              }}
            >
              {bullet.text}
            </p>
          </div>
        );
      })}
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
